if (!customElements.get('nomosu-faq')) {
  customElements.define('nomosu-faq', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.faq-question');
        if (!button || button.closest('nomosu-faq') !== this) return;
        const item = button.closest('.faq-item');
        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
        this.items.forEach((other) => this.setOpen(other, other === item && shouldOpen));
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.faq-item');
        if (!item || !this.contains(item)) return;
        this.items.forEach((other) => this.setOpen(other, other === item));
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        this.items.filter((item) => item.classList.contains('active')).forEach((item) => {
          const answer = item.querySelector('.faq-answer');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        });
      });
      this.querySelectorAll('.faq-answer-inner').forEach((element) => this.resizeObserver.observe(element));
    }

    get items() {
      return [...this.querySelectorAll('.faq-item')];
    }

    setOpen(item, open) {
      const answer = item.querySelector('.faq-answer');
      const button = item.querySelector('.faq-question');
      item.classList.toggle('active', open);
      button.setAttribute('aria-expanded', String(open));
      answer.hidden = !open;
      answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '';
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
